module.exports = "{{#emptySlots}}\n    {{> partials/_empty-slot}}\n{{/emptySlots}}\n"